import React from "react"
import { render, cleanup } from "@testing-library/react"
import { SecondaryNavLinks } from "../SidebarSecondaryList"

export const sidebarNavListItemsNestedSample = [
  {
    title: "Administration",
    children: [
      {
        title: "Happy Tenants",
        href: "/orgs",
        isActive: true,
        children: [
          {
            title: "Nested Happy Tenants",
            href: "/orgs/nested"
          }
        ]
      },
      {
        title: "Users",
        href: "/admin/users"
      }
    ]
  }
]

afterEach(cleanup)

describe("<SidebarSecondaryList />", () => {
  it("properly displays secondary links", () => {
    const { getByText } = render(
      <SecondaryNavLinks secondaryLinkData={sidebarNavListItemsNestedSample} />
    )

    expect(getByText("Administration")).toBeInTheDocument()
    expect(getByText("Happy Tenants")).toBeInTheDocument()
  })
  it("properly displays secondary links with nested children", () => {
    const { getByText } = render(
      <SecondaryNavLinks secondaryLinkData={sidebarNavListItemsNestedSample} />
    )

    expect(getByText("Happy Tenants")).toBeInTheDocument()
    expect(getByText("Nested Happy Tenants")).toBeInTheDocument()
  })
  it("properly displays current active link", () => {
    const { container } = render(
      <SecondaryNavLinks secondaryLinkData={sidebarNavListItemsNestedSample} />
    )

    expect(container.querySelector("[aria-current=page]")).toHaveTextContent(
      "Happy Tenants"
    )
  })
})
